import qs from "qs";
/**
 * @author mam1bg
 * @date 2022-07
 * @licensor Robert Bosch GmbH, 2018
 * @version 1.0.0
 *
 * @jsdoc request
 * @name api.requests:ImpersonationSearchRequest
 */

export class ImpersonationSearchRequest {
  number: string = null;
  name: string = null;
  city: string = null;
  taxNr: string = null;
  payerNumber: string = null;
  payerName: string = null;
  baseSiteUid: string = null;

  constructor(number?, name?, city?, taxNr?, payerNumber?, payerName?, baseSiteUid?) {
    this.number = number;
    this.name = name;
    this.city = city;
    this.taxNr = taxNr;
    this.payerNumber = payerNumber;
    this.payerName = payerName;
    this.baseSiteUid = baseSiteUid;
  }

  /**
   * @jsdoc method
   * @name toQueryString
   * @methodOf api.requests:PtSalesRepSearchRequest
   * @description description
   * Builds query string from class atributes.
   * Uses qs for query string
   */
  toQueryString() {
    return qs.stringify(this, {
      addQueryPrefix: true,
      skipNulls: true,
      sort: null,
    });
  }
}
